/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether the feature resides on the forward or reserve strand
 * @export
 */
export const StrandConstants = {
    Forward: 'Forward',
    Reverse: 'Reverse'
} as const;
export type StrandConstants = typeof StrandConstants[keyof typeof StrandConstants];


export function StrandConstantsFromJSON(json: any): StrandConstants {
    return StrandConstantsFromJSONTyped(json, false);
}

export function StrandConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrandConstants {
    return json as StrandConstants;
}

export function StrandConstantsToJSON(value?: StrandConstants | null): any {
    return value as any;
}

